import React from 'react';
import {Alert, Modal, Text} from '@forecast-it/design-system';
import {FormattedHTMLMessage, FormattedMessage, useIntl} from 'react-intl';

type WarningClientChangeExportedInvoiceBillToMismatchModalProps = {
	closeModal: () => void;
};

const WarningClientChangeExportedInvoiceBillToMismatchModal = ({
	closeModal,
}: WarningClientChangeExportedInvoiceBillToMismatchModalProps): JSX.Element => {
	const {formatMessage} = useIntl();
	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'settings.change_client.warning_invoiced_bill_to.header'} />
			</Modal.Title>
			<Modal.Content>
				<Alert
					text={formatMessage({id: 'settings.change_client.warning_invoiced_bill_to.alert'})}
					type={Alert.TYPE.ERROR}
				/>
				<Text>
					<FormattedHTMLMessage id={'settings.change_client.warning_invoiced_bill_to.body'} />
				</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id={'common.cancel'} />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default WarningClientChangeExportedInvoiceBillToMismatchModal;
